<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12" offset-lg="1">
        <h2 class="mb-3">記事一括発注</h2>
      </v-col>
    </v-row>
    <template v-if="selectedSite">
      <OrderRegistrationForm
        :origin-order-registration="orderRegistration"
        :errors="errors"
        :status="status"
        @update-order-registration="orderRegistration = value"
        @register-orders="registerOrders"
      />
      <v-row>
        <v-col cols="12" lg="10" offset-lg="1">
          <h3 class="subtitle my-3">登録履歴</h3>
          <HistoryTable :order-registrations="orderRegistrations" />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import HistoryTable from '@/components/commons/orderRegistrations/HistoryTable'
import OrderRegistrationForm from '@/components/commons/orderRegistrations/Form'
import headUtilsMixin from '@/mixins/head_utils'
import { deserialize } from 'deserialize-json-api'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    HistoryTable,
    OrderRegistrationForm
  },
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '一括発注',
      orderRegistration: {
        file: null,
        memo: null
      },
      orderRegistrations: [],
      selectedSite: null,
      errors: [],
      status: 'yet'
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (params) => {
        this.selectedSite = this.selectableSites.find(
          (site) => site.siteKey === params.siteKey
        )
        this.fetchOrderRegistrations()
      }
    )
  },
  mounted () {
    this.selectedSite = this.selectableSites.find(
      (site) => site.siteKey === this.$route.params.siteKey
    )
    this.fetchOrderRegistrations()
  },
  methods: {
    fetchOrderRegistrations () {
      if (!this.selectedSite) {
        return true
      }

      axios
        .get('/api/master/order_registrations', {
          params: {
            site_key: this.selectedSiteKey()
          }
        })
        .then(
          ({ data }) => {
            this.orderRegistrations = deserialize(data).data
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    registerOrders (orderRegistration) {
      this.status = 'registering'
      let formData = new FormData()
      const payload = orderRegistration
      Object.keys(payload).forEach((key) => {
        if (payload[key] !== null) {
          formData.append(`order_registration[${key}]`, payload[key])
        }
      })
      formData.append('site_key', this.selectedSiteKey())
      axios
        .post('/api/master/order_registrations', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const orderRegistration = deserialize(data).data
            this.orderRegistrations.unshift(orderRegistration)
            this.errors = []
            this.status = 'success'
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            this.errors = error.response.data.message.split(',')
            this.status = 'error'
          }
        )
        .finally(() => {
          this.fetchOrderRegistrations()
        })
    },
    selectedSiteKey () {
      return this.selectedSite.siteKey
    }
  }
}
</script>
